<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3 is-flex-vcenter">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-empresa') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-column">
                <div class="column">
                    <vs-select
                        :id="generateId(2)"
                        ref="empresaInput"
                        :title="'empresa'"
                        :options="empresas"
                        v-model="empresaTipoPedido.idB2BEmpresa"
                        :search="loadEmpresa"
                        :onChange="updateEmpresa"
                        :placeholder="'empresa'"
                        :invalid="isNull(empresaTipoPedido.idB2BEmpresa)"
                        :loading="loadingEmpresa"
                    />
                </div>
                <div class="column">
                    <vs-select
                        :id="generateId(1)"
                        ref="tipoPedidoInput"
                        :title="'tipopedido'"
                        :options="tipoPedidos"
                        v-model="empresaTipoPedido.idTipoPedido"
                        :search="loadTipoPedidos"
                        :onChange="updateTipoPedido"
                        :placeholder="'tipopedido'"
                        :invalid="isNull(empresaTipoPedido.idTipoPedido)"
                        :loading="loadingTipoPedido"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import TipoPedidoService from "@/services/vendas/TipoPedidoService";

// COMPONENTS
import B2BEmpresaService from "@/services/b2b/B2BEmpresaService";
import B2BEmpresaValidation from "@/services/validations/b2b/B2BEmpresaValidation";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            tipoPedidos:[],
            empresas:[],
            loadingTipoPedido: false,
            loadingEmpresa: false,
            empresaTipoPedido: {
                idB2BEmpresa: null,
                idTipoPedido: null
            },
            service: new TipoPedidoService(this.$http, this.$router),
            empresaService: new B2BEmpresaService(this.$http, this.$router),
            idproduto: 0,
            isLoading: false,
            validate: null,
            msgs: [],
        }
    },
    created() {
        this.carregarDados();
    },
    methods: {
        carregarDados() {
            this.validation = new B2BEmpresaValidation(this.msgs);
        
            this.loadTipoPedidos()
            this.loadEmpresa()
        },
        save() {
            const lotTemp = this.mapOnSave(this.empresaTipoPedido)
            if (this.validation.validate(lotTemp, this.$refs)) {
                this.isLoading = true;
                this.empresaService
                .save(lotTemp)
                .then(value => {
                    if (!value.content) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');

                        this.$router.push({
                            name: 'b2b-politica-comercial-geral',
                            params: { id: value.content.idB2BEmpresa } 
                        })
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(_ => {
                    this.isLoading = false;
                });
            }
        },
        loadTipoPedidos() {
            this.loadingTipoPedido = true;
            this.service
                .findAllCombo()
                .then(this.mapTipoPedidos)
                .then((value) => {
                    this.tipoPedidos = value;
                })
                .catch(e => {
                    console.log(e)
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(_ => {
                    this.loadingTipoPedido = false;
                });
        },
        loadEmpresa() {
            this.loadingEmpresa = true;
            this.empresaService
                .findAllCombo()
                .then(this.mapEmpresa)
                .then((value) => {
                    this.empresas = value;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(() => {
                    this.loadingEmpresa = false;
                });
        },
        updateTipoPedido(idTipoPedido) {
            if (idTipoPedido) {
                this.empresaTipoPedido.idTipoPedido = idTipoPedido;
            } else {
                this.empresaTipoPedido.idTipoPedido = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateEmpresa(empresa) {
            if (empresa) {
                this.empresaTipoPedido.idB2BEmpresa = empresa;
            } else {
                this.empresaTipoPedido.idB2BEmpresa = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        mapTipoPedidos(item) {
            return item.content.map(m => {
                return {
                    id: m.idtipopedido,
                    descricao: m.descricao,
                    label: m.descricao
                };
            });
        },
        mapEmpresa(item){
            return item.content.map((r)=>{
                return {
                    id: r.idB2BEmpresa,
                    descricao: r.rsocial,
                    label: r.rsocial
                }
            })
        },
        mapOnSave(item){
            return {
                idEmpresa: item.idB2BEmpresa.id,
                idTipoPedido: item.idTipoPedido.id
            };
        },
        generateId(numberId){
            return this.$route.name+'-b2b-'+numberId;
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
.bg > #main {
    padding: 20px 20px;
}
</style>